import * as Actions from 'flex/Actions';

import { BACKGROUND_JOB_TYPE } from './BackgroundJobProvider';


export const BackgroundJobStatuses = {
    done: 'done',
    error: 'error',
    sync: 'sync',
    wait: 'wait',
};

/***
 * Jobの状態を取得する
 * @param {Job} job
 * @return {Job.Status}
 */
export const getJobStatus = (job) => {
    return !job.done_at ?
        BackgroundJobStatuses.sync :
        job?.result?.is_success !== undefined ?
            job?.result?.is_success ?  // 同期などの成功判定
                BackgroundJobStatuses.done :
                BackgroundJobStatuses.error :
            job?.is_success ? // CSV エクスポートなどの成功判定
                BackgroundJobStatuses.done :
                BackgroundJobStatuses.error;
};

/** 現状のjobに応じた、次の同期のタスクをdispatchする  */
export function dispatchNextSyncAction(job, dispatch, setLoadingJobInfo, features) {
    switch (job.type) {
        case BACKGROUND_JOB_TYPE.SYNC_GROUP_DRYRUN:
            dispatch(Actions.http.connection.sync.executeGroup(job.uuid));
            setLoadingJobInfo(job.uuid);
            break;

        case BACKGROUND_JOB_TYPE.SYNC_GROUP:
            dispatch(Actions.http.connection.sync.dryRunUser(job.uuid));
            setLoadingJobInfo(job.uuid);
            break;

        case BACKGROUND_JOB_TYPE.SYNC_USER_DRYRUN:
            dispatch(Actions.http.connection.sync.executeUser({ update_password: 0 }, job.uuid));
            setLoadingJobInfo(job.uuid);
            break;

        case BACKGROUND_JOB_TYPE.SYNC_USER:
            if (!features['sync-group']) break;
            dispatch(Actions.http.connection.sync.dryRunGroupMember(job.uuid));
            setLoadingJobInfo(job.uuid);
            break;

        case BACKGROUND_JOB_TYPE.SYNC_MEMBER_DRYRUN:
            dispatch(Actions.http.connection.sync.executeGroupMember(job.uuid));
            setLoadingJobInfo(job.uuid);
            break;

        case BACKGROUND_JOB_TYPE.SYNC_DELETED_USER_DRYRUN:
            dispatch(Actions.http.connection.sync.executeDeleteUser(job.uuid));
            setLoadingJobInfo(job.uuid);
            break;
        default:
            // 上記以外は無視
            break;
    }
}


/***
 * jobInfoMapに指定したtypeのjobInfoが含まれているかどうか
 * @param jobInfoMap
 * @param type
 * @return {boolean}
 */
export const isContainsJobType = (jobInfoMap, type) => {
    return jobInfoMap ?
        Object.values(jobInfoMap).filter(jobInfo => jobInfo?.job?.type === type).length > 0 :
        false;
};
